/* eslint-disable react/no-unknown-property */
import { useLoader } from '@react-three/fiber';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

export default function Model() {
  const { scene: model } = useLoader(GLTFLoader, 'model/model.glb');
  return <primitive object={model} />;
}
